<template>
  <div>
    <PageAllow controller="Settings" action="logisticsApiSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card class="my-5">
          <v-card-title>
            {{ $t("logisticsApiSetting.kdn_form") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- EBusinessID -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("logisticsApiSetting.kdn_ebusiness_id") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="setting.push_kdn_ebusiness_id"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- AppKey -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("logisticsApiSetting.kdn_appkey") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="setting.push_kdn_appkey">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Url -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("logisticsApiSetting.kdn_url") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="setting.push_kdn_url">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 快递鸟版本 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("logisticsApiSetting.logistics_version") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  v-model="setting.push_logistics_version"
                  :items="versions"
                  item-value="value"
                  item-text="text"
                  :label="$t('Global.select')"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Stocks from "@/api/stocks";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Stock.actions.logisticSetting"),
        disabled: true,
        href: "/stocks/stock-logistic-setting",
      },
    ],

    logisticItems() {
      return [
        {
          text: i18n.t("logisticsApiSetting.kdn"),
          value: "2002",
        },
      ];
    },
    versions() {
      return [
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.free"),
          value: "1002",
        },
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.charge"),
          value: "8001",
        },
        {
          text: i18n.t("logisticsApiSetting.logistics_versions.search"),
          value: "8002",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    setting: {},
  }),

  mounted() {
    this.getSettingsFromAPI();
  },

  methods: {
    getSettingsFromAPI() {
      Stocks.fetchOne(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.setting = response.data.stock.logistic_settings_json;
          }
        }.bind(this)
      );
    },

    save() {
      var data = {
        push_kdn_ebusiness_id: this.setting.push_kdn_ebusiness_id,
        push_kdn_appkey: this.setting.push_kdn_appkey,
        push_kdn_url: this.setting.push_kdn_url,
        push_logistics_version: this.setting.push_logistics_version,
      };
      Stocks.stockKdnSave(this.$route.query.stock_id, data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("logisticsApiSetting.saveSuccess"));
            this.getSettingsFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>